import TabPage from '@/components/TabPage';

export default function CustomerRisk() {
  return <TabPage chartFullKeys={['radar']} />;
}
